import * as React from 'react';
import {
  ArrowButtons,
  Breakpoints,
  BreakpointWrapper,
  DesignTokenSizeEnum,
  Gallery as VWGallery,
  GalleryContext,
  GallerySlide as VWGallerySlide,
  Lentils,
} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import {
  GalleryProps,
  GallerySlideProps,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {useEffect, useState} from 'react';

interface GoToComponentPros {
  gotoSlide?: number;
}
function GoToComponent({gotoSlide}: GoToComponentPros): JSX.Element {
  const {triggerChange} = React.useContext(GalleryContext);

  React.useEffect(() => {
    triggerChange(gotoSlide || 0);
  }, []);
  React.useEffect(() => {
    triggerChange(gotoSlide || 0);
  }, [gotoSlide]);

  return <></>;
}

export function Gallery({
  ariaLabel,
  children,
  goToSlide,
  isContentLayer,
}: GalleryProps): JSX.Element {
  const count = children.length;
  function useGalleryResponsiveProps() {
    const [gutter, setGutter] = useState<DesignTokenSizeEnum | undefined>(
      undefined
    );

    useEffect(() => {
      const updateProps = () => {
        const width = window.innerWidth;
        if (width >= 1600) {
          setGutter(DesignTokenSizeEnum.static450);
        } else {
          setGutter(undefined);
        }
      };

      updateProps();
      window.addEventListener('resize', updateProps);
      return () => window.removeEventListener('resize', updateProps);
    }, []);

    return {gutter};
  }

  const {gutter: responsiveGutter} = useGalleryResponsiveProps();
  const gutter = count > 3 ? responsiveGutter : undefined;

  return (
    <VWGallery
      id="tariffs-gallery"
      slidesPerPage={{
        [Breakpoints.default]: 1,
        [Breakpoints.b960]: 2,
        [Breakpoints.b1280]: isContentLayer ? 2 : 3,
        [Breakpoints.b1600]: isContentLayer ? 2 : count > 3 ? 4 : 3,
      }}
      bottomElements={
        <>
          <BreakpointWrapper
            min={Breakpoints.b960}
            max={isContentLayer ? undefined : Breakpoints.b1600}
          >
            <ArrowButtons
              buttonPreviousAriaLabel="To previous slide"
              buttonNextAriaLabel="To next slide"
            />
          </BreakpointWrapper>
          <BreakpointWrapper
            max={
              isContentLayer
                ? undefined
                : count > 3
                  ? Breakpoints.b1600
                  : Breakpoints.b1280
            }
          >
            <LentilsWrapper>
              <Lentils />
            </LentilsWrapper>
          </BreakpointWrapper>
          <GoToComponent gotoSlide={goToSlide} />
        </>
      }
      fadingEdges={'normal'}
      gutter={gutter}
      aria-label={ariaLabel}
    >
      {children}
    </VWGallery>
  );
}

export function GallerySlide({
  ariaLabelledby,
  key,
  children,
}: GallerySlideProps): JSX.Element {
  return (
    <VWGallerySlide key={key} aria-labelledby={ariaLabelledby}>
      {children}
    </VWGallerySlide>
  );
}

const LentilsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${(props) => props.theme.size.static250};
`;
